module.exports = __webpack_public_path__ + "img/testi-right-arrow.9f628665.svg";